// Internal Imports
import { DOCUMENTS } from "../../constants";
import { normaliseTableData } from "../../utils/tableUtils";
import { convertSignersData } from "../../utils/documentUtils";

// Destructuring
const { DOCUMENT_STATUS_CONFIG, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
/**
 * generateDocumentDetails func filters out only necessary keys from API.
 * @param {Object} doc - Refers to the dealtable id to be fetched // "15"
 */
export const generateDocumentDetails = doc => {
  const details = {
    account: doc.account,
    created_by: doc.created_by,
    deadline_date: doc.deadline_date,
    dealTable: doc.deal_tables && doc.deal_tables[0],
    docNo: doc.doc_no,
    fields_used: doc.fields_used,
    id: doc.id,
    isLocked: doc.is_locked,
    is_sent_for_signature: doc.is_sent_for_signature,
    is_signed: doc.is_signed,
    meta_values: doc.meta_values,
    meta_data: doc.meta_data || {},
    name: doc.title,
    docType: doc.type && doc.type.name,
    opportunity: doc.opportunity,
    quoteTable: doc.quotes && doc.quotes[0],
    revisionNo: doc.revision_no,
    showForm: doc.show_form || false,
    stage: doc.stage,
    status: doc.status,
    documentStatus: doc.document_status,
    documentTag: doc.document_tag,
    template_id: doc.template_id,
    template_type: doc.template_type,
    scope: doc.scope,
    objectId: doc.object_id,
    image_base_url: doc.image_base_url,
    signatories:
      doc.signatories &&
      doc.signatories.map(signer => ({
        ...signer,
        signers: convertSignersData(signer.signers),
      })),
    isPdfDocument: doc.is_pdf_document,
    pdfUrl: `${doc.image_base_url}${doc.doc_pdf_path}`,
  };
  return details;
};

export const updateGroupId = (components, newData) => {
  // for (let b = 0; b < content.sections.length; b += 1) {
  //   if
  //     content.sections[b].type === "DealTable" &&
  //     content.sections[b].dealtableView === "GROUPED_SUMMARY" &&
  //     content.sections[b].data.groupSummary
  //   ) {
  //     for (
  //       let m = 0;
  //       m < content.sections[b].data.groupSummary.mergeGroupMapping.length;
  //       m += 1
  //     ) {
  //       if (
  //         content.sections[b].data.groupSummary.mergeGroupMapping[m].groupID !==
  //           newData.dealTable.groups[m].id &&
  //         (content.sections[b].data.groupSummary.mergeGroupMapping[m]
  //           .group_by_value === newData.dealTable.groups[m].group_by_value ||
  //           content.sections[b].data.groupSummary.mergeGroupMapping[m]
  //             .group_by === newData.dealTable.groups[m].group_by)
  //       ) {
  //         content.sections[b].data.groupSummary.mergeGroupMapping[m].groupID =
  //           newData.dealTable.groups[m].id;
  //       }
  //     }
  //     break;
  //   }
  // }
  // return content;
  const dealtableComponentId = Object.keys(components).find(
    componentId => components[componentId].content.type === "DealTable",
  );

  if (dealtableComponentId) {
    const component = components[dealtableComponentId];
    const { data } = component.content;
    if (
      component.content.dealtableView === "GROUPED_SUMMARY" &&
      data.groupSummary &&
      Array.isArray(data.groupSummary.mergeGroupMapping)
    ) {
      for (let m = 0; m < data.groupSummary.mergeGroupMapping.length; m += 1) {
        if (
          data.groupSummary.mergeGroupMapping[m].groupID !==
            newData.dealTable.groups[m].id &&
          (data.groupSummary.mergeGroupMapping[m].group_by_value ===
            newData.dealTable.groups[m].group_by_value ||
            data.groupSummary.mergeGroupMapping[m].group_by ===
              newData.dealTable.groups[m].group_by)
        ) {
          data.groupSummary.mergeGroupMapping[m].groupID =
            newData.dealTable.groups[m].id;
        }
      }
      component.content.data = data;
      components[dealtableComponentId] = component;
    }
  }
};

export const generateDocStatusConfigs = (status, stage) => {
  const docStatusConfigs = [];
  let tempSeqNo;
  DOCUMENT_STATUS_CONFIG.forEach(docStatus => {
    const tempObj = { ...docStatus };
    if (tempObj.stage === stage) {
      tempObj.status = status;
      tempSeqNo = tempObj.seqNo;
    } else {
      tempObj.status = "";
    }
    docStatusConfigs.push(tempObj);
  });

  if (tempSeqNo === 4 && status === "DOCUMENT_CLIENT_SIGNED") {
    docStatusConfigs.forEach(docSt => {
      if (docSt.seqNo === 2) {
        docSt.stage = "Review Passed";
      }
      docSt.className = "status-success";
    });
  } else {
    docStatusConfigs.forEach(docSt => {
      if (docSt.seqNo < tempSeqNo) {
        if (docSt.seqNo === 2) {
          docSt.stage = "Review Passed";
        }
        docSt.className = "status-success";
      }
    });
  }

  return docStatusConfigs;
};

export const getArrangedFormFields = (components, fieldsUsed) => {
  let arrangedFormFields = [];
  if (components && Array.isArray(fieldsUsed) && fieldsUsed.length > 0) {
    Object.keys(components).forEach(componentId => {
      const section = components[componentId]
        ? components[componentId].content
        : {};
      const {
        data: { entityMap: entityData },
      } = section;
      Object.values(entityData).forEach(entity => {
        fieldsUsed.forEach(field => {
          if (
            entity.data &&
            entity.data.dynamicFieldId &&
            field.id === entity.data.dynamicFieldId
          ) {
            arrangedFormFields.push(field);
          }
        });
      });
    });
  }
  arrangedFormFields = Array.from(new Set(arrangedFormFields));
  return arrangedFormFields;
};

export const getFormFieldsOccurrences = (components, fieldsUsed) => {
  const updatedFormFields = getArrangedFormFields(components, fieldsUsed);
  if (
    components &&
    Array.isArray(updatedFormFields) &&
    updatedFormFields.length > 0
  ) {
    Object.keys(components).forEach(componentId => {
      const section = components[componentId]
        ? components[componentId].content
        : {};
      const {
        data: { entityMap: entityData },
      } = section;
      Object.values(entityData).forEach(entity => {
        updatedFormFields.forEach(field => {
          if (!field.occurrences) {
            field.occurrences = [];
          }
          if (
            entity.type === "DYNAMICFIELD" &&
            entity.data &&
            entity.data.dynamicFieldId &&
            field.id === entity.data.dynamicFieldId
          ) {
            field.occurrences = [...field.occurrences, componentId];
          }
        });
      });
    });
  }
  return updatedFormFields;
};

export const getAllFormFields = (components, fieldsUsed) => {
  let form = [];
  const formFieldIds = [];
  if (components && Array.isArray(fieldsUsed) && fieldsUsed.length > 0) {
    Object.keys(components).forEach(componentId => {
      const section = components[componentId]
        ? components[componentId].content
        : {};
      if (section.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
        form.push(...getAllFormFields(section.data.components, fieldsUsed));
      } else if (section.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
        form.push(
          ...getAllFormFields(section.data.header.components, fieldsUsed),
        );
        form.push(
          ...getAllFormFields(section.data.footer.components, fieldsUsed),
        );
      } else if (
        Array.isArray(section.form_field) &&
        section.form_field.length !== 0
      ) {
        section.form_field.forEach(sectionFormField => {
          if (formFieldIds.includes(sectionFormField.dynamicFieldId)) {
            const existingFormField = form.find(
              formField => formField.id === sectionFormField.dynamicFieldId,
            );
            sectionFormField.id.forEach(uuid => {
              if (
                existingFormField &&
                !existingFormField.occurrences.includes(uuid)
              ) {
                existingFormField.occurrences.push(uuid);
              }
            });
          } else {
            formFieldIds.push(sectionFormField.dynamicFieldId);
            const tempObj = fieldsUsed.find(
              dynField => dynField.id === sectionFormField.dynamicFieldId,
            );
            if (tempObj) {
              tempObj.value = sectionFormField.value || "";
              if (tempObj.occurrences) {
                tempObj.occurrences.push(...sectionFormField.id);
              } else {
                tempObj.occurrences = sectionFormField.id;
              }
              // move this to a common function to add default values
              if (
                tempObj.type === "DATE" &&
                (tempObj.value === "" || tempObj.value === null)
              ) {
                tempObj.value = null;
                // tempObj.value = moment(Date()).format("ll");
              } else if (
                tempObj.type === "PERIOD" &&
                (tempObj.value === "" || tempObj.value === null)
              ) {
                tempObj.value = {
                  periodValue: "",
                  periodUom: "",
                };
              } else if (
                tempObj.type === "RATE" &&
                (tempObj.value === "" || tempObj.value === null)
              ) {
                tempObj.value = {
                  rateValue: "",
                  rateUom: "",
                };
              } else if (
                tempObj.type === "PERSON_NAME" &&
                (tempObj.value === "" || tempObj.value === null)
              ) {
                tempObj.value = {
                  firstName: "",
                  lastName: "",
                };
              } else if (
                tempObj.type === "ADDRESS" &&
                (tempObj.value === "" || tempObj.value === null)
              ) {
                tempObj.value = {
                  addressLineOne: "",
                  addressLineTwo: "",
                  city: "",
                  state: "",
                  zip: "",
                  country: "",
                };
              } else if (tempObj.type === "CLAUSE") {
                tempObj.value =
                  Object.prototype.hasOwnProperty.call(
                    section,
                    "clauseOptions",
                  ) && section.clauseOptions
                    ? section.clauseOptions.value
                    : null;
              }
              form.push(tempObj);
            }
          }
        });
      }
      if (
        section.clauseOptions &&
        section.clauseOptions.id &&
        !formFieldIds.includes(section.clauseOptions.id)
      ) {
        const clauseOptionsDetails = fieldsUsed.find(
          dynField => dynField.id === section.clauseOptions.id,
        );
        clauseOptionsDetails.value = section.clauseOptions.value;
        form.push(clauseOptionsDetails);
      }
    });
  }
  form = Array.from(new Set(form));
  return form;
};

export const checkQuoteTableWrapper = components =>
  Boolean(
    Array.isArray(components) &&
      components.find(
        rowComponent =>
          Array.isArray(rowComponent) &&
          rowComponent.find(
            component =>
              component.content.type === "QuoteTableWrapper" ||
              component.content.section_type === "QuoteTableWrapper",
          ),
      ),
  );

export const checkQuoteTable = components =>
  Boolean(
    Array.isArray(components) &&
      components.find(
        rowComponent =>
          Array.isArray(rowComponent) &&
          rowComponent.find(
            component =>
              component.content.type === "QuoteTable" ||
              component.content.section_type === "QuoteTable" ||
              component.content.type === "DealTable" ||
              component.content.section_type === "DealTable",
          ),
      ),
  );

export const getDocumentLayout = components => {
  if (!Array.isArray(components)) return [[]];
  const layout = [];
  components.forEach(component => {
    if (Array.isArray(component)) {
      layout.push(component.map(sec => sec.id));
    } else {
      layout.push([component.id]);
    }
  });
  return layout;
};

const getTextFields = (componentMeta, data) => {
  const { entityMap: entityData } = data;
  const formFields = [];
  if (entityData && Object.keys(entityData).length > 0)
    Object.values(entityData).forEach(entity => {
      if (entity.data && entity.data.dynamicFieldId) {
        formFields.push({
          fieldId: entity.data.dynamicFieldId,
          occurenceId: entity.data.id,
          componentMeta,
        });
      }
    });
  return formFields;
};

const getHTMLFields = (componentMeta, section) => {
  const { data, clauseOptions } = section;
  let formFields = [];
  if (clauseOptions && clauseOptions.id) {
    formFields.push({ fieldId: clauseOptions.id, componentMeta });
  } else if (data && typeof data !== "string") {
    formFields = getTextFields({ ...componentMeta }, data);
  }
  return formFields;
};

const getImageFields = (componentMeta, section) => {
  const { clauseOptions } = section;
  const formFields = [];
  if (clauseOptions && clauseOptions.id) {
    formFields.push({ fieldId: clauseOptions.id, componentMeta });
  }
  return formFields;
};

const getTableFields = (componentMeta, section) => {
  const { data: tableData } = section;
  const { data: rowData } = normaliseTableData(tableData);
  let formfields = [];
  rowData.forEach((row, rowIndex) => {
    const { data: columnData } = row;
    columnData.forEach((column, colIndex) => {
      const {
        data: { data: cellData },
      } = column;
      let cellFields = [];
      if (cellData && typeof cellData !== "string") {
        cellFields = getTextFields(
          {
            ...componentMeta,
            itemType: "Table",
            tableRow: rowIndex,
            tableCol: colIndex,
          },
          cellData,
        );
      }
      if (Array.isArray(cellFields) && cellFields.length > 0)
        formfields = [...formfields, ...cellFields];
    });
  });
  return formfields;
};

const getCoverpageFields = (componentMeta, component) => {
  const { data } = component;
  let formfields = [];
  const { layout, components } = data;
  if (Array.isArray(layout) && layout.length > 0) {
    layout.forEach(rowData => {
      if (Array.isArray(rowData) && rowData.length > 0) {
        rowData.forEach(sectionId => {
          const section = components[sectionId].content;
          // eslint-disable-next-line no-use-before-define
          const fields = getComponentFields(
            {
              ...componentMeta,
              blockType: "Coverpage",
            },
            section,
          );
          if (Array.isArray(fields) && fields.length > 0) {
            formfields = [...formfields, ...fields];
          }
        });
      } else if (rowData && !Array.isArray(rowData)) {
        const section = components[rowData].content;
        // eslint-disable-next-line no-use-before-define
        const fields = getComponentFields(
          {
            ...componentMeta,
            blockType: "Coverpage",
          },
          section,
        );
        if (Array.isArray(fields) && fields.length > 0) {
          formfields = [...formfields, fields];
        }
      }
    });
  }
  return formfields;
};

const getHeaderFooterFields = (componentMeta, component) => {
  const { data } = component;
  const { header, footer } = data;
  let formfields = [];
  const { layout: hlayout, components: hcomponents } = header;
  if (Array.isArray(hlayout) && hlayout.length > 0) {
    hlayout.forEach(rowData => {
      if (Array.isArray(rowData) && rowData.length > 0) {
        rowData.forEach(sectionId => {
          const section = hcomponents[sectionId].content;
          // eslint-disable-next-line no-use-before-define
          const fields = getComponentFields(
            {
              ...componentMeta,
              blockType: "Header",
            },
            section,
          );
          if (Array.isArray(fields) && fields.length > 0) {
            formfields = [...formfields, ...fields];
          }
        });
      } else if (rowData && !Array.isArray(rowData)) {
        const section = hcomponents[rowData].content;
        // eslint-disable-next-line no-use-before-define
        const fields = getComponentFields(
          {
            ...componentMeta,
            blockType: "Header",
          },
          section,
        );
        if (Array.isArray(fields) && fields.length > 0) {
          formfields = [...formfields, fields];
        }
      }
    });
  }

  const { layout: flayout, components: fcomponents } = footer;
  if (Array.isArray(flayout) && flayout.length > 0) {
    flayout.forEach(rowData => {
      if (Array.isArray(rowData) && rowData.length > 0) {
        rowData.forEach(sectionId => {
          const section = fcomponents[sectionId].content;
          // eslint-disable-next-line no-use-before-define
          const fields = getComponentFields(
            {
              ...componentMeta,
              blockType: "Footer",
            },
            section,
          );
          if (Array.isArray(fields) && fields.length > 0) {
            formfields = [...formfields, ...fields];
          }
        });
      } else if (rowData && !Array.isArray(rowData)) {
        const section = fcomponents[rowData].content;
        // eslint-disable-next-line no-use-before-define
        const fields = getComponentFields(
          {
            ...componentMeta,
            blockType: "Footer",
          },
          section,
        );
        if (Array.isArray(fields) && fields.length > 0) {
          formfields = [...formfields, fields];
        }
      }
    });
  }

  return formfields;
};

const getComponentFields = (componentMeta, component) => {
  let componentFields = [];
  if (component.type === DOCUMENT_COMPONENT_TYPES.HTML) {
    componentFields = getHTMLFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.IMAGE) {
    componentFields = getImageFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
    componentFields = getTableFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
    componentFields = getCoverpageFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
    componentFields = getHeaderFooterFields(componentMeta, component);
  }
  return componentFields;
};

export const getFormFields = (components, fieldsUsed) => {
  let formfields = [];
  // get all the fields
  Object.keys(components).forEach(componentId => {
    const section = components[componentId]
      ? components[componentId].content
      : {};
    const componentMeta = {
      componentId,
      itemType: section.type,
      blockType: "Body",
    };
    const componentFields = getComponentFields(componentMeta, section);
    if (Array.isArray(componentFields) && componentFields.length > 0)
      formfields = [...formfields, ...componentFields];
  });
  // get all unique fields with occurences
  let arrangedFields = [];
  formfields.forEach(field => {
    const fieldDetails = fieldsUsed.find(df => df.id === field.fieldId);
    if (fieldDetails) {
      const isAvailable = arrangedFields.findIndex(
        df => df.id === field.fieldId,
      );
      if (isAvailable !== -1) {
        arrangedFields[isAvailable].occurrences = [
          ...arrangedFields[isAvailable].occurrences,
          field.componentMeta,
        ];
      } else {
        if (
          fieldDetails.value === null &&
          fieldDetails.meta &&
          fieldDetails.meta.default
        ) {
          fieldDetails.value = fieldDetails.meta && fieldDetails.meta.default;
        }

        arrangedFields = [
          ...arrangedFields,
          {
            ...fieldDetails,
            occurrences: [
              { ...field.componentMeta, occurenceId: field.occurenceId },
            ],
          },
        ];
      }
    }
  });
  return arrangedFields;
};



// WEBPACK FOOTER //
// ./src/actions/QuotationActions/QuotationMethods.js